import gql from "graphql-tag";

export const SEND_LOG_TO_BACKEND = gql`
  query uiLogMessage($msg: String!){
    uiLogMessage(msg: $msg)
  }
`